<template>
	<div class="mod-register">
		<layout-header></layout-header>
		<div style="height: 152px"></div>
		<div class="page_content">
			<div class="page_main page_wrapper">
				<div class="site_top">
					<h3>用户注册</h3>
					<span class="line"></span>
				</div>
				<div class="form_panel">
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" size="small" label-width="110px">
						<input type="password" hidden autocomplete="new-password" />
						<div class="title">
							<span>账户信息</span>
						</div>
						<el-row type="flex" justify="space-around">
							<el-col :span="10">
								<el-form-item label="委托类型" prop="userType">
									<el-radio-group v-model="ruleForm.userType" @change="userTypeChanege">
										<el-radio label="2">外部用户</el-radio>
										<el-radio label="1">内部用户</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-col>
							<el-col :span="10">
								<el-form-item label="用户名" prop="username">
									<el-input v-model="ruleForm.username" autocomplete="new-password" readonly onfocus="this.removeAttribute('readonly')"></el-input>
									<el-input style="position: fixed; bottom: -9999999px"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row type="flex" justify="space-around">
							<el-col :span="10">
								<el-form-item label="设置密码" prop="password">
									<el-input type="password" name="A2" style="position: fixed; bottom: -9999999px"></el-input>
									<el-input type="password" name="A2" autocomplete="new-password" v-model="ruleForm.password" readonly onfocus="this.removeAttribute('readonly')"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="10">
								<el-form-item label="确认密码" prop="comfirmPassword">
									<el-input type="password" name="A1" style="position: fixed; bottom: -9999999px"></el-input>
									<el-input type="password" name="A1" autocomplete="new-password" v-model="ruleForm.comfirmPassword" readonly onfocus="this.removeAttribute('readonly')"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row type="flex" justify="space-around">
							<el-col :span="10">
								<el-form-item label="手机号码" prop="phone">
									<el-input v-model="ruleForm.phone"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="10">
								<el-form-item label="验证码" prop="captchaPhone">
									<div class="captchabox">
										<el-input v-model="ruleForm.captchaPhone"></el-input>
										<span class="captext" @click.stop.prevent="getCaptchaHandle">{{ showText }}</span>
									</div>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row type="flex" justify="space-around">
							<el-col :span="10">
								<el-form-item label="姓名" prop="name">
									<el-input v-model="ruleForm.name"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="10">
								<el-form-item label="邮箱" prop="email">
									<el-input v-model="ruleForm.email"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row type="flex" justify="space-around">
							<el-col :span="10">
								<el-form-item label="QQ号" prop="qq">
									<el-input v-model="ruleForm.qq"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="10">
								<el-form-item label="微信号" prop="wx">
									<el-input v-model="ruleForm.wx"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<div class="upInfo">
							<el-row type="flex" justify="space-around">
								<el-col :span="10">
									<el-form-item label="电子签名" prop="electronName">
										<el-row>
											<el-col :span="12">
												<el-upload
													class="sign-uploader euploader"
													:action="fileUploadUrl"
													:show-file-list="false"
													:on-success="handleSignSuccess"
													accept=".png,.jpg,.jpeg,.bmp,.tif,.pcx,.svg,.webp"
												>
													<img v-if="signImageUrl" :src="signImageUrl" class="signimg" />
													<div v-else class="desc">
														<i class="el-icon-plus euploader-icon"></i>
														<p>上传签名</p>
													</div>
												</el-upload>
											</el-col>
											<el-col :span="12">
												<div class="shili">
													<span>示例：</span>
													<img style="width: 105px" src="@/assets/img/shili.png" alt="" />
												</div>
											</el-col>
										</el-row>
									</el-form-item>
								</el-col>
								<el-col :span="10">
									<el-form-item label="用户头像" prop="avatar">
										<el-upload
											class="avatar-uploader euploader"
											:action="fileUploadUrl"
											:show-file-list="false"
											:on-success="handleAvatarSuccess"
											accept=".png,.jpg,.jpeg,.bmp,.tif,.pcx,.svg,.webp"
										>
											<img v-if="avatarImageUrl" :src="avatarImageUrl" class="avatar" />
											<div v-else class="desc">
												<i class="el-icon-plus euploader-icon"></i>
												<p>上传头像</p>
											</div>
										</el-upload>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row type="flex" justify="space-around">
								<el-col :span="10">
									<el-form-item label="">
										<div class="tips">
											<h3>电子签名制作方式</h3>
											<p>
												方法一：在白纸上手写签名，使用Photoshop等图片处理软件制作成无背底的图片。
												<br />
												方法二：使用手机备忘录或类似APP，选择色黑较粗的笔书写，截取签名并上传图片。 要求：签名四周不留白，图片为PNG格式。
											</p>
										</div>
									</el-form-item>
								</el-col>
								<el-col :span="10"> </el-col>
							</el-row>
						</div>
						<div class="title">
							<span>委托单位</span>
						</div>
						<el-row type="flex" justify="space-around" v-if="ruleForm.userType == '1'">
							<el-col :span="10">
								<el-form-item label="单位名称" prop="deptName">
									<el-input v-model.trim="ruleForm.deptName" @keydown.native="keydown($event)"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="10">
								<el-form-item prop="department" label="部门/学院/课题组名称">
									<!-- <template v-slot:label>
										<span class="mylableline">部门/学院/课题组名称</span>
									</template> -->
									<el-input v-model.trim="ruleForm.department" @keydown.native="keydown($event)"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<template v-if="ruleForm.userType == '1'">
							<el-row type="flex" justify="space-around">
								<el-col :span="10">
									<el-form-item label="项目名称" prop="proName">
										<el-input v-model.trim="ruleForm.proName" @keydown.native="keydown($event)"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="10">
									<el-form-item label="项目编号" prop="proNumber">
										<el-input v-model.trim="ruleForm.proNumber" @keydown.native="keydown($event)"></el-input>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row type="flex" justify="space-around">
								<el-col :span="10">
									<el-form-item label="项目类别" prop="proType">
										<el-select v-model="ruleForm.proType" class="w100" placeholder="请选择项目类别">
											<el-option :label="item.val" :value="item.code" v-for="item of proTypeOptions" :key="item.code"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="10">
									<el-form-item label="研究方向" prop="researchDrct">
										<el-select v-model="ruleForm.researchDrct" class="w100" placeholder="请选择研究方向">
											<el-option :label="item.val" :value="item.code" v-for="item of yjfxOptions" :key="item.code"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row type="flex" justify="space-around">
								<el-col :span="10">
									<el-form-item label="项目负责人" prop="proLeader">
										<el-input v-model.trim="ruleForm.proLeader" @keydown.native="keydown($event)"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="10">
									<el-form-item label="联系方式" prop="proLeaderTel">
										<el-input v-model.trim="ruleForm.proLeaderTel" @keydown.native="keydown($event)"></el-input>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row type="flex" justify="space-around">
								<el-col :span="10">
									<el-form-item label="结算负责人" prop="proSettler">
										<el-input v-model.trim="ruleForm.proSettler" @keydown.native="keydown($event)"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="10">
									<el-form-item label="联系方式" prop="proSettlerTel">
										<el-input v-model.trim="ruleForm.proSettlerTel" @keydown.native="keydown($event)"></el-input>
									</el-form-item>
								</el-col>
							</el-row>

							<el-row type="flex" justify="space-around">
								<el-col :span="10">
									<el-form-item label="项目结题时间" prop="proConclusionTime">
										<el-date-picker
											type="date"
											placeholder="项目结题时间"
											v-model="ruleForm.proConclusionTime"
											format="yyyy-MM-dd"
											value-format="timestamp"
											style="width: 100%"
										></el-date-picker>
									</el-form-item>
								</el-col>
								<el-col :span="10">
									<el-form-item label="区域邮编" prop="postcode">
										<el-input v-model="ruleForm.postcode"></el-input>
									</el-form-item>
								</el-col>
							</el-row>
						</template>
						<el-row type="flex" justify="space-around" v-if="ruleForm.userType == '1'">
							<el-col :span="10">
								<el-form-item label="所在地" prop="location">
									<el-input v-model="ruleForm.location"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="10">
								<el-form-item label="详细地址" prop="addr">
									<el-input v-model="ruleForm.addr"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row type="flex" justify="space-around" v-if="ruleForm.userType == '2'">
							<el-col :span="10">
								<el-form-item label="单位名称" prop="deptName">
									<el-input v-model.trim="ruleForm.deptName" @keydown.native="keydown($event)"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="10">
								<el-form-item label="详细地址" prop="addr">
									<el-input v-model="ruleForm.addr"></el-input>
								</el-form-item>
							</el-col>
						</el-row>

						<div class="title">
							<span>开票信息</span>
						</div>
						<el-row type="flex" justify="space-around">
							<el-col :span="10">
								<el-form-item label="单位名称" prop="billComName">
									<el-input v-model="ruleForm.billComName"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="10">
								<el-form-item label="单位地址" prop="billComAddress">
									<el-input v-model="ruleForm.billComAddress"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row type="flex" justify="space-around">
							<el-col :span="10">
								<el-form-item label="单位电话" prop="billComPhone">
									<el-input v-model="ruleForm.billComPhone"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="10">
								<el-form-item label="税务登记号" prop="billRegNumber">
									<el-input v-model="ruleForm.billRegNumber"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row type="flex" justify="space-around">
							<el-col :span="10">
								<el-form-item label="开户银行" prop="billBankName">
									<el-input v-model="ruleForm.billBankName"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="10">
								<el-form-item label="开户账号" prop="billBankNumber">
									<el-input v-model="ruleForm.billBankNumber"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-form-item>
							<div class="btn-control">
								<el-button type="primary" round class="elbtnColor" @click="submitForm" size="medium">确认注册</el-button>
							</div>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</div>
		<layout-footer></layout-footer>
	</div>
</template>

<script>
import { isMobile, isEmail } from '@/utils/validate'
import { RSAEncrypt } from '@/utils'
import LayoutFooter from '../layout/Layout-footer.vue'
import LayoutHeader from '../layout/Layout-header.vue'
export default {
	components: { LayoutHeader, LayoutFooter },
	data() {
		var validateBus = (rule, value, callback) => {
			console.log(this.ruleForm.electronName)
			if (!this.ruleForm.electronName) {
				callback(new Error('上传电子签名'))
			} else {
				callback()
			}
		}
		// var validateAvatar = (rule, value, callback) => {
		// 	if (!this.ruleForm.avatar) {
		// 		callback(new Error('上传用户头像'))
		// 	} else {
		// 		callback()
		// 	}
		// }
		var validateMobile = (rule, value, callback) => {
			if (!isMobile(value)) {
				callback(new Error('手机号格式错误'))
			} else {
				callback()
			}
		}
		var validateEmail = (rule, value, callback) => {
			if (!isEmail(value)) {
				callback(new Error('邮箱格式错误'))
			} else {
				callback()
			}
		}
		// var validatePassword = (rule, value, callback) => {
		//   const reg = /(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{6,16}/;
		//   if (value == "" || value == undefined || value == null) {
		//     callback();
		//   } else {
		//     if (!reg.test(value)) {
		//       callback(new Error("仅由英文字母，数字以及特殊字符组成，6到16位"));
		//     } else {
		//       callback();
		//     }
		//   }
		// };
		// var validateComfirmPassword = (rule, value, callback) => {
		//   if (!/\S/.test(value)) {
		//     callback(new Error("确认密码不能为空"));
		//   } else if (this.ruleForm.password !== value) {
		//     callback(new Error("确认密码与密码输入不一致"));
		//   } else {
		//     callback();
		//   }
		// };
		return {
			avatarImageUrl: '',
			signImageUrl: '',
			proTypeOptions: [],
			yjfxOptions: [],
			ruleForm: {
				userType: '1',
				username: '',
				password: '',
				comfirmPassword: '',
				phone: '',
				captchaPhone: '',
				name: '',
				email: '',
				qq: '',
				wx: '',
				electronName: '',
				avatar: '',
				deptName: '',
				department: '',
				proName: '',
				proNumber: '',
				proType: '',
				researchDrct: '',
				proConclusionTime: '',
				proLeader: '',
				proLeaderTel: '',
				proSettler: '',
				proSettlerTel: '',
				location: '',
				addr: '',
				postcode: '',
				billComName: '',
				billComAddress: '',
				billComPhone: '',
				billRegNumber: '',
				billBankName: '',
				billBankNumber: '',
			},
			rules: {
				userType: [{ required: true, message: '请选择委托类型', trigger: 'change' }],
				username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
				password: [
					{ required: true, message: '请输入密码', trigger: 'blur' },
					//{ validator: validatePassword, trigger: "blur" },
				],
				comfirmPassword: [
					{ required: true, message: '请输入确认密码', trigger: 'blur' },
					// { validator: validateComfirmPassword, trigger: "blur" },
				],
				phone: [
					{ required: true, message: '请输入手机号码', trigger: 'blur' },
					{ validator: validateMobile, trigger: 'blur' },
				],
				captchaPhone: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
				name: [
					{ required: true, message: '请输入姓名', trigger: 'blur' },
					{ min: 0, max: 20, message: '长度在20个字符内', trigger: 'blur' },
				],
				electronName: [{ required: true, validator: validateBus, trigger: 'change' }],
				// avatar: [{ required: true, validator: validateAvatar, trigger: 'change' }],
				department: [{ required: true, message: '请输入部门/学院/课题组名称', trigger: 'blur' }],
				deptName: [{ required: true, message: '请输入单位名称', trigger: 'blur' }],
				proName: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
				proNumber: [{ required: true, message: '请输入项目编号', trigger: 'blur' }],
				proType: [{ required: true, message: '请选择项目类别', trigger: 'change' }],
				researchDrct: [{ required: true, message: '请选择研究方向', trigger: 'change' }],
				proConclusionTime: [{ required: true, message: '项目结题时间', trigger: 'change' }],
				proLeader: [{ required: true, message: '请输入项目负责人', trigger: 'blur' }],
				proLeaderTel: [{ required: true, message: '项目负责人联系方式', trigger: 'blur' }],
				proSettler: [{ required: true, message: '请输入结算负责人', trigger: 'blur' }],
				proSettlerTel: [{ required: true, message: '结算负责人联系方式', trigger: 'blur' }],
				// location: [{ required: true, message: "请输入所在地", trigger: "blur" }],
				// addr: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
				// postcode: [{ required: true, message: "请输入区域邮编", trigger: "blur" }],
				email: [
					{ required: true, message: '请输入邮箱', trigger: 'blur' },
					{ validator: validateEmail, trigger: 'blur' },
				],
			},
			countdown: 60,
			showText: '获取验证码',
		}
	},
	computed: {
		fileUploadUrl() {
			return window.SITE_CONFIG.fileUpload
		},
	},
	created() {
		this.init()
	},
	methods: {
		keydown(e) {
			if (e.keyCode == 32) {
				e.returnValue = false
			}
		},
		init() {
			this.getDicByCode('PROTYPE')
			this.getDicByCode('YJFX')
		},
		// 表单提交
		submitForm() {
			this.$refs['ruleForm'].validate(valid => {
				if (valid) {
					let params = {
						...this.ruleForm,
						password: RSAEncrypt(this.ruleForm.password),
					}
					this.$http.post(this.$api.userApi.register, params).then(({ data }) => {
						if (data.code === 200) {
							this.$message({
								message: '注册成功',
								type: 'success',
								duration: 1500,
								onClose: () => {
									this.$refs['ruleForm'].resetFields()
									//this.isSuccess = true;
								},
							})
						}
					})
				}
			})
		},
		// 获取字典
		getDicByCode(code) {
			this.$http.get(this.$api.dicApi.getDicList, { params: { code } }).then(({ data }) => {
				code == 'PROTYPE' && (this.proTypeOptions = data.data)
				code == 'YJFX' && (this.yjfxOptions = data.data)
			})
		},
		// 获取验证码
		getCaptchaHandle() {
			if (!this.ruleForm.phone) return this.$message.warning('请输入手机号码')
			if (!isMobile(this.ruleForm.phone)) return this.$message.warning('手机号格式错误')
			if (this.countdown != 60) return
			let params = {
				phone: this.ruleForm.phone,
			}
			this.$http
				.post(this.$api.userApi.getpCaptcha, params)
				.then(({ data }) => {
					console.log(data)
					this.$message.success('短信发送成功')
					this.countdown = 60
					this.settime()
				})
				.catch(() => {})
		},
		settime() {
			//发送验证码倒计时
			let _this = this
			if (_this.countdown == 0) {
				_this.showText = '获取验证码'
				_this.countdown = 60
				return false
			} else {
				_this.showText = _this.countdown + 's'
				_this.countdown = _this.countdown - 1
			}
			setTimeout(function () {
				_this.settime()
			}, 1000)
		},
		// 电子签名
		handleSignSuccess(res, file) {
			console.log(res)
			this.signImageUrl = URL.createObjectURL(file.raw)
			this.ruleForm.electronName = res.data.storage.fileUrl
			this.$refs.ruleForm.validateField('electronName')
		},
		// 用户头像
		handleAvatarSuccess(res, file) {
			this.avatarImageUrl = URL.createObjectURL(file.raw)
			this.ruleForm['avatar'] = res.data.storage.fileUrl
			this.$refs.ruleForm.validateField('avatar')
		},
		userTypeChanege(val) {
			this.$refs['ruleForm'].resetFields()
			this.ruleForm.userType = val
		},
	},
}
</script>
<style lang="scss">
.euploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
}
.euploader .el-upload:hover {
	border-color: #409eff;
}
.euploader .desc {
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 22px;
	color: #2962b0;
	font-weight: bold;
	p {
		padding: 0;
		margin: 0;
	}
}
.signimg {
	width: 112px;
	height: 112px;
	display: block;
}
.euploader-icon {
	font-size: 28px;
	text-align: center;
}
.avatar-uploader .el-upload {
	background: #e6e6e6;
	.desc {
		border-radius: 50%;
		background: #fff;
	}
	.avatar {
		width: 112px;
		height: 112px;
		display: block;
		border-radius: 50%;
	}
}
</style>

<style lang="scss" scoped>
.mod-register {
	// display: flex;
	// flex-direction: column;
	height: 100vh;
	min-width: max-content;
	.page_content {
		// flex: 1;
		margin-bottom: 20px;
		// overflow: auto;
	}
	.page_main {
		margin-top: 16px;
		background: #fff;
		padding: 40px 88px;
		border-radius: 16px;
		.site_top {
			text-align: center;
			margin-bottom: 30px;
			h3 {
				font-size: 20px;
				line-height: 20px;
				margin: 0;
				padding: 0;
			}
			.line {
				display: inline-block;
				width: 24px;
				border: 1px solid #b7b7b7;
				margin-top: 10px;
			}
		}
		.form_panel {
			.title {
				padding: 6px 10px;
				margin-bottom: 25px;
				background: #f2f3f5;
			}
			.tips {
				h3 {
					line-height: 20px;
					margin: 0;
				}
			}
			.btn-control {
				text-align: center;
				margin-top: 60px;
				.elbtnColor {
					width: 160px;
				}
			}
		}
	}
}
</style>
